export default __webpack_public_path__ + "static/media/avatar_whitney8.d80e6395.mp3";